export const PERSISTENT_VOLUMES_SEARCH_URL_KEY = 'stop-pv-list';
export const PERSISTENT_VOLUME_PRESSURE_PERCENT = 80;
export const PERSISTENT_VOLUME_OVERPROVISIONED_PERCENT = 40;
